export function CameraIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M0.5 3.5C0.5 2.94772 0.947715 2.5 1.5 2.5H1.96482C2.29917 2.5 2.6114 2.3329 2.79687 2.0547L3.20313 1.4453C3.3886 1.1671 3.70083 1 4.03518 1H5.96482C6.29917 1 6.6114 1.1671 6.79687 1.4453L7.20313 2.0547C7.3886 2.3329 7.70083 2.5 8.03518 2.5H8.5C9.05228 2.5 9.5 2.94772 9.5 3.5V8C9.5 8.55228 9.05228 9 8.5 9H1.5C0.947715 9 0.5 8.55228 0.5 8V3.5Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.5 5.5C6.5 6.32843 5.82843 7 5 7C4.17157 7 3.5 6.32843 3.5 5.5C3.5 4.67157 4.17157 4 5 4C5.82843 4 6.5 4.67157 6.5 5.5Z'
        // text color
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
